export default {
  data() {
    return {
      selectedPeriod: 'Quarterly',
      inclusionItems: [
        { title: 'Trust Activities', description: 'Summary of all trust operations and transactions', type: 'activity' },
        { title: 'Compliance Status', description: 'KYC, regulatory, and governance compliance', type: 'compliance' },
        { title: 'Key Stakeholders', description: 'Trustees, beneficiaries, and founder information', type: 'stakeholders' },
        { title: 'Risks & Recommendations', description: 'Identified risks and mitigation strategies', type: 'risk' }
      ]
    };
  }
};